const PREFER_COOKIE_NAME = "rc2_prefer_next_ui";
const PREFER_COOKIE_VALUE = "1";
const COOKIE_MAX_AGE_SEC = 60 * 60 * 24 * 365;

export const NEXT_TIMERS_PATH = "/next/timers";

const OIDC_CALLBACK_PATH = "/api/oidc_callback";

function buildCookieString(name, value, maxAgeSeconds) {
  const parts = [
    `${name}=${value}`,
    `Max-Age=${maxAgeSeconds}`,
    "Path=/",
    "SameSite=Lax",
  ];
  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    parts.push("Secure");
  }
  return parts.join("; ");
}

export function setPreferNextUiCookie(enabled) {
  if (typeof document === "undefined") {
    return;
  }
  if (enabled) {
    document.cookie = buildCookieString(
      PREFER_COOKIE_NAME,
      PREFER_COOKIE_VALUE,
      COOKIE_MAX_AGE_SEC
    );
  } else {
    document.cookie = buildCookieString(PREFER_COOKIE_NAME, "", 0);
  }
}

export function getPreferNextUiEnabled() {
  if (typeof document === "undefined") {
    return false;
  }
  const prefix = `${PREFER_COOKIE_NAME}=`;
  const cookies = document.cookie.split(";").map((c) => c.trim());
  for (const c of cookies) {
    if (c.indexOf(prefix) === 0) {
      return c.slice(prefix.length) === PREFER_COOKIE_VALUE;
    }
  }
  return false;
}

export function isReferrerOidcCallback() {
  if (typeof document === "undefined" || !document.referrer) {
    return false;
  }
  try {
    const u = new URL(document.referrer);
    return u.pathname === OIDC_CALLBACK_PATH;
  } catch {
    return false;
  }
}
